<template>
  <el-autocomplete
    v-model="searchDirection"
    value-key="vicinity"
    class="input-lg"
    :debounce="1000"
    :fetch-suggestions="fetchSearchDirection"
    placeholder="Dirección..."
    :trigger-on-focus="false"
    @select="handleSelect"
  />
</template>

<script>
import ThirdService from '@/services/ThirdService'

export default {
  data() {
    return {
      isLoading: false,
      searchDirection: null,
    }
  },
  watch: {
    searchDirection: function clean(newVal) {
      if (newVal === '' || newVal === null) this.$emit('clean-data')
    },
  },
  methods: {
    fetchSearchDirection(queryString, cb) {
      const vm = this
      if (queryString === '' || queryString === undefined) return

      vm.isLoading = true
      ThirdService.sugerenciasDireccion({
        direccion: queryString,
      })
        .then(resp => {
          cb(resp.data)
        })
        .catch(() => {
          const sugerencias = []
          cb(sugerencias)
        })
        .finally(() => {
          vm.isLoading = false
        })
    },
    async handleSelect(item) {
      const { position } = item
      const [lat, lon] = position
      const response = await ThirdService.searchGeolocalizacion({ lat, lon })

      if (response.status && response.status === 200) {
        const { address } = response.data
        this.$emit('result-search', address)
      }
    },

  },
}
</script>

<style>
.el-autocomplete {
  width: 100%;
}
</style>
